module.exports = __webpack_public_path__ + "static/media/talk01_medium.f416fccf.jpg";